<div class="aacbc">
  <input [title]="params.colDef.headerName" type="checkbox" [(ngModel)]="val" [disabled]="isDisabled" (change)="valChanged($event)" />
</div>
